export default class CSVHelper {

  static getAllFieldList(formularList) {
    let result = {}

    // add all fields to object for fast access: allFieldList[nativename] = field
    for (let i = 0; i < formularList.length; i++) {
      let fieldList = formularList[i].formularFields.formularFlatList
      for (let y = 0; y < fieldList.length; y++) {
        result[fieldList[y].nativename] = fieldList[y]
      }
    }
    return result
  }

  static getCSSClassnameFromTitle(title) {
    if (!title) return ""
    return title.toLowerCase().replaceAll(" ", "").replaceAll("&", "").replaceAll("-", "")
  }

  static getKeyValueListOfDependentFields(formularList, changedField) {

    // 1st: get all fields from model as paramID/value array with actual values
    let fieldKeyValueList = []
    let fieldKeyValueObj = {}

    if (changedField.parentFormPointer) {
      let parentFieldList = changedField.parentFormPointer.parentForm
      if (parentFieldList) {
        for (let j = 0; j < parentFieldList.length; j++) {
          // build small key/value parameterlist for small paylod to compValueChange call
          let field = parentFieldList[j]
          let value = field.valueListQueryID && field.value && field.value.indexOf("||") !== -1 ? field.value.substr(field.value.indexOf("||") + 2) : field.value // parse subquery format, send only value: label||value
          let keyValue = {key: field.nativename, value}
          fieldKeyValueList.push(keyValue)
          fieldKeyValueObj[field.nativename] = {field, value}
        }
      }
    }

    // Collect dependent fields of changedField
    let dependentFields = {}
    let allFieldList = this.getAllFieldList(formularList)

    // add changed field itself to keyvalue list for compValueChange call
    let value = changedField.valueListQueryID && changedField.value && changedField.value.indexOf("||") !== -1 ? changedField.value.substr(changedField.value.indexOf("||") + 2) : changedField.value // parse subquery format, send only value: label||value
    let keyValue = {key: changedField.nativename, value, classID: changedField.classID}
    fieldKeyValueList.push(keyValue)
    fieldKeyValueObj[changedField.nativename] = {changedField, value}

    // iterate through all fields and find dependencies to changed field
    // add all referenced fields which are part of the sql
    Object.values(allFieldList).forEach(field => {
      let fieldDep = field.fieldDependencies
      if (fieldDep && fieldDep.indexOf(changedField.nativename) !== -1) {
        let fieldDepList = fieldDep.split(";")
        fieldDepList.forEach(depField => {
          dependentFields[depField] = ""  // value is not used, only the name is relevant
          // console.log("add dep. field: " + depField, ", value:", value, ", from: ", field.nativename)
        })
      }
    })

    // console.log("dependentFields for ", changedField.nativename, ": ", dependentFields)

    // add per sql referenced fields of dependent fields
    for (let depFieldName in dependentFields) {
      // if (dependentFields.hasOwnProperty(depFieldName) && depFieldName !== changedField.nativename) {
      let depField = allFieldList[depFieldName]
      if (depField) {
        let value = depField.valueListQueryID && depField.value && depField.value.indexOf("||") !== -1 ? depField.value.substr(depField.value.indexOf("||") + 2) : depField.value // parse subquery format, send only value: label||value
        let keyValue = {key: depField.nativename, value, classID: depField.classID}
        fieldKeyValueList.push(keyValue)
        fieldKeyValueObj[depField.nativename] = {depField, value}
      }
    }

    return fieldKeyValueList
  }

  static getKeyValueListOfField(formularList, changedField) {
    // 1st: get all fields from model as paramID/value array with actual values
    let fieldKeyValueList = []

    // Collect dependent fields of changedField
    let dependentFields = {}
    let allFieldList = this.getAllFieldList(formularList)

    // iterate through all fields and find dependencies to changed field
    // add all referenced fields which are part of the sql
    if (changedField.fieldDependencies) {
      let fieldDepList = changedField.fieldDependencies.split(";")
      fieldDepList.forEach(depFieldName => {
        let depField = allFieldList[depFieldName]
        if (depField) {
          let value = depField.valueListQueryID && depField.value && depField.value.indexOf("||") !== -1 ? depField.value.substr(depField.value.indexOf("||") + 2) : depField.value // parse subquery format, send only value: label||value
          let keyValue = {key: depField.nativename, value, classID: depField.classID}
          if (!fieldKeyValueList.some(el => el.key === depField.nativename)) {
            fieldKeyValueList.push(keyValue)
          }
        }
      })
    }
    return fieldKeyValueList
  }
}
